/*!
 * devextreme-angular
 * Version: 22.1.11
 * Build date: Mon Aug 28 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

/* tslint:disable:use-input-property-decorator */

import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf
} from '@angular/core';





import {
    NestedOptionHost,
} from 'devextreme-angular/core';
import { DxoGaugeIndicator } from './base/gauge-indicator';


@Component({
    selector: 'dxo-value-indicator',
    template: '',
    styles: [''],
    providers: [NestedOptionHost],
    inputs: [
        'arrowLength',
        'backgroundColor',
        'baseValue',
        'beginAdaptingAtRadius',
        'color',
        'horizontalOrientation',
        'indentFromCenter',
        'length',
        'offset',
        'palette',
        'secondColor',
        'secondFraction',
        'size',
        'spindleGapSize',
        'spindleSize',
        'text',
        'type',
        'verticalOrientation',
        'width'
    ]
})
export class DxoValueIndicatorComponent extends DxoGaugeIndicator implements OnDestroy, OnInit  {

    protected get _optionPath() {
        return 'valueIndicator';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  declarations: [
    DxoValueIndicatorComponent
  ],
  exports: [
    DxoValueIndicatorComponent
  ],
})
export class DxoValueIndicatorModule { }
